export default __webpack_public_path__ + "static/media/enable_previous_image.141dcbfb.svg";